import { Button, MenuItem, Select } from "@mui/material";
import { Add, ArrowBack } from "@mui/icons-material";
import { useEffect, useState } from "react";
import {
  create_booking_dynamic_route,
  get_single_booking_dynamic_route,
  update_booking_dynamic_route,
} from "../auth/service";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

// Removed quill-better-table imports

const BookingLocations = () => {
  const [getRoute, setRoute] = useState();
  const [getStatus, setStatus] = useState(true);
  const [routeError, setRouteError] = useState(""); // Add error state

  const navigate = useNavigate();

  const location = useLocation();

  const dynamicBookingLocationId = location.state?.id;

  console.log(dynamicBookingLocationId, "dynamicBookingLocationId");

  const handleRouteChange = (e) => {
    const value = e.target.value;
    // Only allow letters (no numbers, spaces, or special characters)
    if (/^[A-Za-z-]*$/.test(value)) {
      setRoute(value);
      setRouteError("");
    } else {
      setRouteError(
        "Only letters are allowed. No numbers, spaces, or special characters."
      );
    }
  };

  useEffect(() => {
    if (dynamicBookingLocationId) {
      (async () => {
        try {
          const data = await get_single_booking_dynamic_route(
            dynamicBookingLocationId
          );
          const routeData = data?.data;
          setRoute(routeData.route || "");
          setStatus(routeData.status);
          console.log(routeData, "route data");
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [dynamicBookingLocationId]);

  const handleSaveBookingRoute = async () => {
    if (!getRoute || routeError) {
      setRouteError("Please enter a valid route name (letters only).");
      return;
    }

    const payload = {
      route: getRoute,
      status: getStatus,
    };

    try {
      if (dynamicBookingLocationId) {
        const data = await update_booking_dynamic_route(
          payload,
          dynamicBookingLocationId
        );
        if (!data.error) {
          toast.success(data?.message || "Booking Route Updated successfully");
          setRoute("");
          setTimeout(() => {
            navigate("/dashboard/bookinglocation/dynamic-location-routes");
          }, 800);
        } else {
          toast.error(data?.message || "Error while updating booking route");
        }
      } else {
        const data = await create_booking_dynamic_route(payload);
        console.log("Booking Route Saved successfully:", data);
        if (!data.error) {
          setTimeout(() => {
            navigate("/dashboard/bookinglocation/dynamic-location-routes");
          }, 800);
        } else {
          toast.error(data?.message || "Error while saving booking route");
        }
      }
    } catch (e) {
      console.log("Error saving booking route:", e);
      toast.error("Failed to create category");
    }
  };

  const handleNavigateBack = () => {
    console.log("Back button clicked");
    navigate("/dashboard/bookinglocation/dynamic-location-routes");
  };

  return (
    <div className="category-add">
      <div className="category-header-container">
        <span className="metaTag-header">
          {dynamicBookingLocationId
            ? "Edit Booking Location Routes"
            : "Add Booking Location Routes"}
        </span>

        <div className="btn-flex">
          <Button
            variant="contained"
            className="bordered-button"
            onClick={() => {
              handleSaveBookingRoute(dynamicBookingLocationId);
            }}
          >
            {dynamicBookingLocationId
              ? "UPDATE BOOKING LOCATION ROUTE"
              : "SAVE BOOKING LOCATION ROUTE"}
          </Button>
          <Button
            variant="outlined"
            className="bordered-button"
            startIcon={<ArrowBack />}
            onClick={handleNavigateBack}
          >
            BACK
          </Button>
        </div>
      </div>

      <div className="container">
        <label className="label">Booking page Location Route</label>{" "}
        <input
          type="text"
          className="input"
          name="category"
          value={getRoute}
          onChange={handleRouteChange}
          style={{ width: "25%" }}
        />
        {routeError && (
          <div style={{ color: "red", marginTop: 4 }}>{routeError}</div>
        )}
      </div>

      <div className="container">
        <label className="label">Status</label>

        <Select
          style={{ height: 40, width: "25%" }}
          // value={cityDetails.active}
          // onChange={handleChange("active")}
          onChange={(e) => setStatus(e.target.value)}
          value={getStatus}
        >
          <MenuItem value={true}>Active</MenuItem>
          <MenuItem value={false}>Inactive</MenuItem>
        </Select>
      </div>
      <div className="container">
        <div
          className="seo-list"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        ></div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default BookingLocations;
